import type { CompanySummary } from "@/Domain/CompanySummary";
import { EnumLocLabelType } from "@/Domain/EnumLocLabelType";
import type { LocPrintRequest } from "@/Domain/LocPrintRequest";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import { getLabelTypePrintOption as getPrintOption } from "@/Domain/PrintLocModalOptions";
import { api } from "@/api";
import { handleResponsePromiseAsync } from "./apiHelper";
import { useNotificationStore } from "@/stores/useNotificationStore";
import type { LocPrintUkdSingleProductRequest } from "@/Models/Requests/LocPrintUkdSingleProductRequest";

export const getLabelTypePrintOption = (
  labelType: EnumLocLabelType | string,
  companySummary: CompanySummary
) => {
  if (typeof labelType === "string") {
    labelType = EnumLocLabelType[labelType as keyof typeof EnumLocLabelType];
  }
  const options = getPrintOption(labelType);
  if (!options) return options;
  options.letterHeaderOptions = options?.letterHeaderOptions.filter(
    (option) => {
      return (
        !option.validateRestrictions ||
        option.validateRestrictions(companySummary)
      );
    }
  );
  return options;
};

export const printLocAsync = async (model: LocPrintRequest) => {
  const notificationStore = useNotificationStore();
  const locPromise = api.postDownload("VueLocPrint", model);

  return handleResponsePromiseAsync(
    locPromise,
    () => {},
    "printLocHelper.vue",
    "printLocAsync",
    () => {
      notificationStore.notify({
        message: "Error downloading LOC. Please try again.",
        type: NotificationTypeEnum.error,
        duration: 5000,
      });
    }
  );
};

export const printLocUkdSingleProductAsync = async (
  model: LocPrintUkdSingleProductRequest
) => {
  const notificationStore = useNotificationStore();
  const locPromise = api.postDownload("LocPrintUkdSingleProduct", model);

  return handleResponsePromiseAsync(
    locPromise,
    () => {},
    "printLocHelper.vue",
    "printLocUkdSingleProductAsync",
    () => {
      notificationStore.notify({
        message: "Error downloading LOC. Please try again.",
        type: NotificationTypeEnum.error,
        duration: 5000,
      });
    }
  );
};
